import React from 'react';
import { Box, Grid2 } from '@mui/material';
import { getLabel } from 'framework/utils';
import SortButton from '../DataGridLayout/TableHead/SortButton';

interface GridHeaderProps {
  children: React.ReactElement[];
  buttons?: React.ReactElement[];
  isShowHeader?: boolean;
  expandable?: boolean;
  buttonContainerSize?: number;
  expandIconInFirstCell?: boolean;
}

const GridHeader = ({
  children,
  buttons = [],
  isShowHeader = true,
  expandable = false,
  buttonContainerSize = 1,
  expandIconInFirstCell,
}: GridHeaderProps) => {
  if (!isShowHeader) return null;

  const renderHeaderCell = (child: React.ReactElement, index: number) => {
    const { source, sortSource, label, isSortable, size = 2 } = child.props;
    const headerText = getLabel(label, source);
    const key = `${label || source || index}`;

    if (index === 0 && expandable) {
      return (
        <Grid2 key={key} size={size} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ pl: 3 }} />
          {isSortable ? <SortButton source={sortSource ?? source} label={headerText} /> : <>{headerText}</>}
        </Grid2>
      );
    }

    return (
      <Grid2 key={key} size={size}>
        {isSortable ? <SortButton source={sortSource ?? source} label={headerText} /> : <>{headerText}</>}
      </Grid2>
    );
  };

  const renderButtons = () => (buttons.length > 0 ? <Grid2 size={buttonContainerSize}>{/* Buttons */}</Grid2> : null);

  return (
    <Grid2
      container
      wrap="nowrap"
      sx={{
        px: 2,
        py: 1,
        width: '100%',
        color: 'primary.main',
        borderBottom: '1px solid',
        borderBottomColor: 'border.default',
        boxSizing: 'border-box',
        justifyContent: 'space-between',
        fontSize: '12px',
      }}
    >
      {expandable && !expandIconInFirstCell && (
        <Grid2 size={0.5} minWidth="23px">
          {/* Expand button placeholder */}
        </Grid2>
      )}

      {children.map(renderHeaderCell)}

      {renderButtons()}
    </Grid2>
  );
};

export default GridHeader;
